/*
 * Sidebar auth block — shows "Sign in with Google" for logged-out users and a
 * user avatar/name + logout dropdown for logged-in users.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import { GoogleLogo, SignOut, User as UserIcon } from "@phosphor-icons/react";
import { toast } from "sonner";
import { startGoogleLogin, useAuth } from "../lib/auth";

export default function AuthBlock() {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return (
      <div
        className="mx-3 mb-3 px-4 py-3 font-mono text-[11px] text-zinc-500"
        data-testid="auth-loading"
      >
        checking session…
      </div>
    );
  }

  if (!user) {
    return (
      <button
        onClick={startGoogleLogin}
        data-testid="google-login-btn"
        className="mx-3 mb-3 px-4 py-3 flex items-center gap-3 border border-white/10 bg-[#0a0a0a] hover:bg-[#ccff00]/10 hover:border-[#ccff00]/40 hover:text-[#ccff00] text-zinc-200 transition-colors group"
      >
        <GoogleLogo size={18} weight="duotone" />
        <span className="font-medium tracking-wide text-sm">Sign in with Google</span>
      </button>
    );
  }

  const initial = (user.name || user.email || "?").trim()[0]?.toUpperCase() || "?";

  const onLogout = async () => {
    await logout();
    toast.success("Signed out");
  };

  return (
    <div
      className="mx-3 mb-3 border border-white/10 bg-[#0a0a0a]"
      data-testid="auth-userblock"
    >
      <div className="px-3 py-3 flex items-center gap-3 border-b border-white/5">
        {user.picture ? (
          <img
            src={user.picture}
            alt=""
            className="w-8 h-8 border border-white/10 object-cover"
            referrerPolicy="no-referrer"
          />
        ) : (
          <div className="w-8 h-8 bg-[#ccff00]/20 border border-[#ccff00]/30 flex items-center justify-center text-[#ccff00] font-mono text-sm">
            {initial}
          </div>
        )}
        <div className="min-w-0 flex-1">
          <div
            className="text-xs text-zinc-200 truncate"
            data-testid="auth-user-name"
          >
            {user.name || user.email}
          </div>
          <div className="text-[10px] text-zinc-500 font-mono truncate">
            {user.email}
          </div>
        </div>
        <UserIcon size={14} className="text-zinc-500 flex-shrink-0" />
      </div>
      <button
        onClick={onLogout}
        data-testid="logout-btn"
        className="w-full px-3 py-2 flex items-center gap-2 text-xs font-mono text-zinc-500 hover:text-[#ccff00] hover:bg-[#ccff00]/5 transition-colors"
      >
        <SignOut size={12} />
        sign out
      </button>
    </div>
  );
}
